import React from 'react'
import Layout from '../Layout'
import ReactHtmlParser from 'react-html-parser'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
export default function BinStore(props) {
    return (
        <>
            <SEOTAG page="Bin Store" />
            <Layout props={props}>
                <div className="px-5 py-4 stctPgWrpr">
                    <span>{ReactHtmlParser(global.storeDetails.sell_with_us)}</span>
                </div>
            </Layout>
        </>
    )
}
